import { regStepIds } from './eventConstants';

export function getStepAfterDivisionSelection({ event, unRegisteredPlayers }) {
    const players = unRegisteredPlayers || [];
    const shouldShowPartnerQuestions = players.filter(player => player.canAnswerEventQuestions).length > 0;
    const isCurrentMemberInUnregisteredPlayers = players.find(player => player.isCurrentUser);
    const shouldShowSelfQuestions = !isCurrentMemberInUnregisteredPlayers &&
        event?.currentMember?.answers?.length < event?.eventQuestions?.length;
    const eventHasQuestions = event?.eventQuestions?.length > 0;

    // Placeholder for a future event-level SMS opt-in setting; no event exposes one yet.
    const shouldShowSmsOptIn = false;

    if (shouldShowSmsOptIn || (eventHasQuestions && (shouldShowPartnerQuestions || shouldShowSelfQuestions))) {
        return regStepIds.QUESTIONS;
    }
    return regStepIds.CONFIRM;
}
